import { FC } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";

import MDButton from "components/MDButton";
import { styles } from "./SelfReportMismatchDialog.styles";

type SelfReportMismatchDialogProps = {
  open: boolean;
  onUpdateSelection: () => void;
  onConfirmOriginal: () => void;
};

const SelfReportMismatchDialog: FC<SelfReportMismatchDialogProps> = ({
  open,
  onUpdateSelection,
  onConfirmOriginal,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const useStyles = makeStyles()(() => styles(theme));
  const { classes } = useStyles();

  const handleDialogClose = (
    _event: object,
    reason: "backdropClick" | "escapeKeyDown",
  ) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      disableEscapeKeyDown
      aria-labelledby="self-report-mismatch-dialog-title"
      aria-describedby="self-report-mismatch-dialog-body"
      data-test-id="self-report-mismatch-dialog"
      PaperProps={{ className: classes.dialogPaper }}
    >
      <DialogTitle
        id="self-report-mismatch-dialog-title"
        className={classes.title}
        component="h2"
      >
        {t("SelfReportScreen:mismatchDialog:title")}
      </DialogTitle>
      <DialogContent className={classes.body}>
        <p id="self-report-mismatch-dialog-body">
          {t("SelfReportScreen:mismatchDialog:body")}
        </p>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <MDButton
          color="primary"
          variant="contained"
          type="button"
          className={classes.primaryButton}
          onClick={onUpdateSelection}
          data-test-id="self-report-mismatch-update-selection"
        >
          {t("SelfReportScreen:mismatchDialog:primaryButton")}
        </MDButton>
        <MDButton
          color="primary"
          variant="text"
          type="button"
          className={classes.secondaryButton}
          onClick={onConfirmOriginal}
          data-test-id="self-report-mismatch-confirm-original"
        >
          {t("SelfReportScreen:mismatchDialog:secondaryButton")}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default SelfReportMismatchDialog;
